
export const ERROR_SET = `calculator/ERROR_SET`
export const ERROR_CLEAR = `calculator/ERROR_CLEAR`
export const ERROR_CLEAR_ALL = `calculator/ERROR_CLEAR_ALL`

export const SET = 'calculator/SET'
export const CLEAR = 'calculator/CLEAR'
